// extracted by mini-css-extract-plugin
export var assigneeBadge = "_jg-0";
export var assigneeDetails = "_jg-1";
export var assigneeInfo = "_jg-2";
export var dropdownContainer = "_jg-4";
export var dropdownImage = "_jg-5";
export var editAssigneeInfo = "_jg-3";
export var editAssigneeModalContainer = "_jg-6";
export var hidden = "_jg-8";
export var input = "_jg-7";